export const API_DATE_FORMAT = 'yyyy-MM-dd';

export const DATE_PLACEHOLDER = 'dd.mm.yyyy';

export const REQUIRED_LANG = 'en';

export const EMPTY_DATA_PLACEHOLDER = '---';
